export default {
  validationLoading: false,
  validationError: null,
  validationSuccess: false,
};
